export default "__VITE_ASSET__29e81221__"